import { ActivityPresentBanner } from 'approot/activity-builder/present/activity-present-banner.style';
import Text from 'approot/shared/styles/typography/text';
import {
  UnidentifiedAccessBanner,
  UnidentifiedAccessBannerContent,
} from 'approot/student-class-to-do/unidentified-access-banner.style';

type PresentAnswersBannerProps = {
  isDrawerDetailsActive: boolean;
};

const PresentClosedAssignmentBanner = ({
  isDrawerDetailsActive,
}: PresentAnswersBannerProps) => {
  return (
    <ActivityPresentBanner $isDrawerDetailsActive={isDrawerDetailsActive}>
      <UnidentifiedAccessBanner>
        <UnidentifiedAccessBannerContent>
          <Text>
            Your teacher closed this assignment. Your work is saved. You can
            look at it. You can't change your answers.
          </Text>
        </UnidentifiedAccessBannerContent>
      </UnidentifiedAccessBanner>
    </ActivityPresentBanner>
  );
};

export default PresentClosedAssignmentBanner;
